import request from "@/config/utils/request";

// 列表查询
export function querySeekPageForSupplierLists(data) {
  return request({
    url: "/apis/ebs/spc/seek/querySeekPageForSupplier", // 后端接口
    method: "post",
    data
  });
}

// 详情查询
export function querySeekDetailForSupplierDetail(data) {
  return request({
    url: "/apis/ebs/spc/seek/querySeekDetailForSupplier", // 后端接口
    method: "post",
    data
  });
}

// 详查询库存情况(新)
export function queryNewSeekSkuForSupplier(data) {
  return request({
    url: "/apis/ebs/spc/seekPurchase/queryNewSeekSkuForSupplier", // 后端接口
    method: "post",
    data
  });
}

// 详查询库存情况
export function querySeekSkuForSupplier(data) {
  return request({
    url: "/apis/ebs/spc/seek/querySeekSkuForSupplier", // 后端接口
    method: "post",
    data
  });
}

// 供应商报价
export function supplierQuote(data) {
  return request({
    url: "/apis/ebs/spc/seek/supplierQuote", // 后端接口
    method: "post",
    data
  });
}
// 采购询价 供应商报价
export function ecSupplierQuote(data) {
  return request({
    url: "/apis/ebs/spc/seek/ecSupplierQuote", // 后端接口
    method: "post",
    data
  });
}
// 供应商报名
export function supplierRegister(data) {
  return request({
    url: "/apis/ebs/spc/seek/supplierRegister", // 后端接口
    method: "post",
    data
  });
}

// 计算金额
export function getShowPrice(data) {
  return request({
    url: "/apis/ebs/spc/seek/getShowPrice",
    method: "post",
    data
  });
}

// 综合金计算金额
export function getShowFinalQuotePrice(data) {
  return request({
    url: "/apis/ebs/spc/seek/getShowFinalQuotePrice",
    method: "post",
    data
  });
}

// 商品品牌列表
export function queryPropBrandValuesByClassifyCodes(data) {
  return request({
    url: "/apis/ebs/spc/seek/queryPropBrandValuesByClassifyCodes",
    method: "post",
    data
  });
}
// 商品品牌列表
export function catalogueSkuList(data) {
  return request({
    url: "/apis/ebs/spc/seek/catalogueSkuList",
    method: "post",
    data
  });
}

// 商品数据过滤
export function querySeekDetailBySkuIdForSupplier(data) {
  return request({
    url: "/apis/ebs/spc/seek/querySeekDetailBySkuIdForSupplier",
    method: "post",
    data
  });
}

// 品牌列表
export function queryPropBrandValuesByClassifyCodeAndTskuId(data) {
  return request({
    url: "/apis/ebs/spc/seek/queryPropBrandValuesByClassifyCodeAndTskuId",
    method: "post",
    data
  });
}
